import React from 'react';
import classnames from 'classnames';
import * as styles from './style.module.scss';

import { Link } from 'gatsby';

import Icon from 'components/UI/Icon';
import Socials from 'components/Elements/Socials/Links';
import useSocialData from 'hooks/graphql/useSocials';

const Finish = ({ data }) => {
  const socialsData = useSocialData();

  return (
    <div className={styles.finish}>
      <div>
        <p className={styles.finish_head_suptitle}>
          <Icon name={'checked-circled'} className={'cr-text-3'} />
          <span className={classnames('cr-subheader-4 cr-text-3')}>
            {data.sendText}
          </span>
        </p>
        <p className={classnames('cr-h3', styles.finish_head_title)}>
          {data.title}
        </p>
        <p className={classnames('cr-reg')}>{data.subtitle}</p>
      </div>

      <div className={styles.finish_main}>
        <p
          className={classnames(
            'cr-main cr-subheader-3 cr-txt-up',
            styles.finish_main_title
          )}
        >
          {data.next}
        </p>

        <div className={styles.finish_main_links}>
          <Link to={data.blog.to?.uri} className={styles.largelink}>
            <div className={styles.largelink_l}>
              <p className={classnames('cr-lead', styles.largelink_title)}>
                {data.blog.title}
              </p>
              <p className={classnames('cr-reg')}>{data.blog.subtitle}</p>
            </div>
            <div className={styles.largelink_r}>
              <Icon
                name={'corner-arrow-small-bold'}
                className={classnames('cr-text-3', styles.largelink_arrow)}
              />
            </div>
          </Link>
        </div>
      </div>

      <div className={styles.finish_bot}>
        <p className={classnames('cr-lead', styles.finish_bot_title)}>
          {data.connect.title}
        </p>

        <p className={classnames('cr-reg', styles.finish_bot_desc)}>
          {data.connect.subtitle}
        </p>

        <Socials socials={socialsData} mod={'black'} />
      </div>
    </div>
  );
};

export default Finish;
